// extracted by mini-css-extract-plugin
export var audienceCard = "audienceCard-module--audienceCard--ca3c8";
export var dark = "audienceCard-module--dark--b34e0";
export var image = "audienceCard-module--image--06595";
export var imageContainer = "audienceCard-module--imageContainer--d9608";
export var light = "audienceCard-module--light--05c56";
export var text = "audienceCard-module--text--f0993";
export var textContainer = "audienceCard-module--textContainer--8a370";